module.exports = __webpack_public_path__ + "static/media/tagRemove.cce21795.svg";